import React from 'react';
import { useWorkflowById } from '../hooks/useWorkflowById/useWorkflowById';
import styles from './DroppableCanvas.module.scss';
import WorkflowTabs from '../WorkflowTabs/WorkflowTabs';

const DroppableCanvas: React.FC = () => {
  const { isLoading, isFetching } = useWorkflowById();
  const loading = isLoading || isFetching;
  return (
    <div className={styles.container}>
      {loading && <div>Workflow is loading</div>}
      {!loading && <WorkflowTabs />}
    </div>
  );
};

export default DroppableCanvas;
